import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { apiV2 } from "api/firebase";
import { CommonNotificationType } from "@evennt-tech/api-v2-core";

const TRANSLATIONS_QUERY_PREFIX = "productCategoryTranslations";

const translationsQueryKey = (categoryId: string) =>
  [TRANSLATIONS_QUERY_PREFIX, categoryId] as const;

export const useProductCategoryLocalizationState = (categoryId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: translationsQueryKey(categoryId),
    queryFn: () =>
      apiV2.productCategory.getTranslationsByCategory({ categoryId }),
    enabled: !!categoryId,
  });
  return { translations: data ?? [], isLoading };
};

export const useProductCategoryLocalizationActions = () => {
  const queryClient = useQueryClient();

  const autoCatchTranslations = useCallback(() => {
    apiV2.notification.subscribe({
      key: CommonNotificationType.UPDATE_PRODUCT_CATEGORY_TRANSLATIONS,
      callback: () =>
        queryClient.invalidateQueries({
          queryKey: [TRANSLATIONS_QUERY_PREFIX],
          predicate: (query) => !!query.queryKey[1],
          refetchType: "all",
        }),
    });

    return () => {
      apiV2.notification.unsubscribe({
        key: CommonNotificationType.UPDATE_PRODUCT_CATEGORY_TRANSLATIONS,
      });
    };
  }, [queryClient]);

  return { autoCatchTranslations };
};
